import { ApplePayButtonLogo } from '@/components/Wallets/WalletButton/ApplePayButtonLogo';

/**
 * The Apple Pay method box's content. Apple Pay is the one method with no
 * `logo/apple.svg` on the APM logo CDN, so instead of the `<img>` every other
 * method renders it paints the same mark our wallet buttons do — filled dark,
 * for a light box — which is also the only mark Apple's guidelines allow.
 */
export const ApplePayCard = () => <ApplePayButtonLogo fill="currentColor" className="h-5 w-auto" />;
